var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('region-retailers-section',{staticClass:"region-retailers-section-module",attrs:{"title":_vm.attributes.regionRetailers_title,"intro":_vm.attributes.regionRetailers_intro,"retailers":_vm.mappedRetailers}})}
var staticRenderFns = []

export { render, staticRenderFns }